<div class="ui-g-12 text-right" style="float:unset;">
  <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="goBack()"
    label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g-12">
  <app-kontable #table data-testid="table" title="Coupon" [columns]="[
    {field: 'coupon_code', title: 'campaign.couponCode'},
    {field: 'barcode', title: 'promotion.barCode'},
    {field: 'cust_name', title: 'campaign.customerName'},
    {field: 'cust_surname', title: 'campaign.customerSurname'},
    {field: 'emission_date_start', title: 'campaign.emissionStartDate', type: 'date', filterType: dateFilter},
    {field: 'emission_date_end', title: 'campaign.emissionEndDate', type: 'date', filterType: dateFilter},
    {field: 'fruition_date_start', title: 'campaign.fruitionStartDate', type: 'date', filterType: dateFilter},
    {field: 'fruition_date_end', title: 'campaign.fruitionEndDate', type: 'date', filterType: dateFilter},
    'card_no'
  ]" [titles]="['loyalty.card_no']" [service]="couponService" [paginationType]="paginationType" [showRecoverButton]="false" [showInfoButton]="false"
    [showAddButton]="false" [showDeleteButton]="true" [showDetailsButton]="false" [showEditButton]="true"
    [showReport]="false" (onEdit)="openEditForm($event)" (onRemove)="deleteCoupon($event)">
  </app-kontable>
</div>
<p-dialog *ngIf="showEditForm" [(visible)]="showEditForm" [modal]="true" header="{{'campaign.editCoupon' | translate}}"
  [width]="600" [draggable]="false" [resizable]="false">
  <app-coupon-form [coupon]="couponToEdit" (couponSaved)="saveCoupon($event)">
  </app-coupon-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-list/coupon-list.component.html